import { z } from 'zod';

export const AREA = 'Area';
export const DISTRICT = 'District';
export const SECTOR = 'Sector';
export const SUBUNIT = 'SubUnit';

export const AORHierarchyNodeSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string().nullable(),
  parentItemId: z.uuid().nullable(),
  location: z.string().nullable(),
  currentLocationGeom: z.string().nullable(),
  /**
   * Hierarchy levels are optional display labels. AORs created by hand in
   * Organization Settings carry a parent but no level, so the tree is built
   * from `parentItemId` and these are null.
   */
  levelName: z.string().nullable(),
  levelOrder: z.number().int().nullable(),
});

export const AORHierarchyPayloadSchema = z.array(AORHierarchyNodeSchema);

export type AORHierarchyNode = z.infer<typeof AORHierarchyNodeSchema>;
export type AORHierarchyPayload = z.infer<typeof AORHierarchyPayloadSchema>;
